export const selectDesignProperties = {
  '&.MuiInputBase-root': {
    borderBottomLeftRadius: '4px',
    borderBottomRightRadius: '4px',
  },
  '&.MuiInputBase-root:before': {
    borderBottom: 'none !important',
  },
  '&.MuiInputBase-root:after': {
    borderBottom: '3px solid #1976d2',
    borderBottomLeftRadius: '3px',
    borderBottomRightRadius: '3px',
    bottom: '-1px',
  },
};
